import React, { useCallback, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx";
import { api } from "../../../../Apis/interceptor";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";

const ExcelUploader = ({ onCloseUploadPopup, targetUpload, customerId, targetData }) => {
  const toastRef = useRef();
  const [loading, setLoading] = useState(false);
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();

    reader.onload = async (event) => {
      const data = new Uint8Array(event.target.result);
      try {
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
      } catch (error) {
        toastRef.current.showToast({
          type: "error",
          message: "Upload correct file",
        });
      }

      try {
        if (targetUpload) {
          var res = await api.post(
            `api/v1/uploadSelectedGoalsQualitative/` + customerId,
            {
              file: file, customer_id: customerId
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          if (res.data.length > 0) {
            targetData(res.data)
            onCloseUploadPopup();
          } else {
            toastRef.current.showToast({
              type: 'error',
              message: 'Please select a valid File for uploading'
            });
          }
        } 
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    };

    reader.readAsArrayBuffer(file);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps()} style={dropzoneStyle}>
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <input {...getInputProps()} />
      <i className="pi pi-upload"></i>
      <p>Drag 'n' drop an Excel file here, or click to select one</p>
    </div>
  );
};

const dropzoneStyle = {
  border: "2px dashed #cccccc",
  borderRadius: "5px",
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
};

export default ExcelUploader;
